import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="orb -top-20 left-1/4 w-[700px] h-[700px] bg-indigo-700/30" />
      <div className="orb bottom-0 right-1/4 w-[600px] h-[600px] bg-blue-600/25" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-[2rem] overflow-hidden border border-white/10 bg-gradient-to-br from-[#0d0d18] via-[#0a0a14] to-black p-10 md:p-20 text-center">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(67,56,202,0.25),transparent_60%)]" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 glass rounded-full pl-2 pr-4 py-1.5 text-xs text-zinc-300">
              <span className="h-5 w-5 grid place-items-center rounded-full bg-blue-500/20">
                <Sparkles className="h-3 w-3 text-blue-300" />
              </span>
              Free Strategy Call · 30 mins · No commitment
            </div>
            <h2 className="mt-7 font-display text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tighter leading-[1.02]">
              Ready to scale<br />your brand <span className="text-gradient">globally?</span>
            </h2>
            <p className="mt-6 max-w-xl mx-auto text-base md:text-lg text-zinc-400 leading-relaxed">
              Book a free strategy call. We'll audit your store, analyze your funnel, and show you
              exactly where the next $1M is hiding.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/contact#book"
                data-testid="final-cta-button"
                className="inline-flex items-center justify-center gap-2 bg-white text-black hover:bg-zinc-200 transition-all hover:scale-[1.02] rounded-full px-8 py-4 font-semibold"
              >
                Schedule Free Strategy Call
                <ArrowUpRight className="h-4 w-4" />
              </Link>
              <Link
                to="/case-studies"
                data-testid="final-cta-cases-link"
                className="inline-flex items-center justify-center gap-2 glass hover:bg-white/[0.07] transition rounded-full px-8 py-4 font-semibold text-white"
              >
                See Case Studies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
